module.exports = "/assets/images/times_16e52d.svg";